import React from 'react';
import { useLocation } from 'react-router-dom';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import classNames from 'classnames';

import { RouteDefinition, routeDefinitions } from '../../../routes';
import { useTour } from '@reactour/tour';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const currentLocation = useLocation();
  const tour = useTour();

  const getActiveClasses = (routeDefinition: RouteDefinition) => {
    return classNames({
      'rounded-md': true,
      'pl-3 bg-green-600': currentLocation.pathname.includes(routeDefinition.route!),
    });
  };

  const nextTourStep = () => {
    if (tour.isOpen)
      setTimeout(() => {
        tour.setCurrentStep(tour.currentStep + 1);
      }, 300);
  };

  return (
    <>
      {isOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          className="fixed inset-0 z-30 bg-black/40 min-[1300px]:hidden"
          onClick={onClose}
        />
      )}
      <aside
        id="logo-sidebar"
        className={clsx(
          'fixed top-0 left-0 z-40 h-screen w-64 border-r pt-20 transition-transform',
          'bg-gradient-to-t from-robin-egg-blue-75 via-rich-black-10 to-robin-egg-blue-15',
          'border-robin-egg-blue-15 backdrop-blur-20 min-[1300px]:translate-x-0 min-[1300px]:bg-black',
          isOpen ? 'translate-x-0' : '-translate-x-full',
        )}
        aria-label="Sidebar"
      >
        <div className="h-full overflow-y-auto px-3 pb-4 dark:bg-gray-800">
          <ul className="flex h-full flex-col place-content-between font-medium">
            <div>
              {Object.keys(routeDefinitions)
                .filter((rdk) => routeDefinitions[rdk].isSidebar)
                .slice(1)
                .map((rd, index) => (
                  <li
                    key={index}
                    onClick={
                      routeDefinitions[rd].route === 'applications' ||
                      routeDefinitions[rd].route === 'templates' ||
                      routeDefinitions[rd].route === 'labs'
                        ? () => nextTourStep()
                        : undefined
                    }
                    className={getActiveClasses(routeDefinitions[rd])}
                  >
                    <Link
                      to={`/${routeDefinitions[rd].route}`}
                      onClick={onClose}
                      className={clsx(
                        'flex items-center space-x-3 rounded-md p-2 text-gray-100',
                        routeDefinitions[rd].class,
                      )}
                    >
                      {routeDefinitions[rd].icon}
                      <span className="text-gray-100">{routeDefinitions[rd].text}</span>
                    </Link>
                  </li>
                ))}
            </div>
            <li className="rounded-sm">
              <a
                href="https://pritset.com/docs/intro"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 rounded-md p-2 text-gray-100"
              >
                <BookOpenIcon className="h-6 w-6"></BookOpenIcon>
                <span className="text-gray-100">Docs</span>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
}
